(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/tips-info.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/tips-info.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.maltipset.views.TipsInfo = Backbone.Marionette.View.extend({
    template: function(data) {
      return svs.maltipset.templates.tips_info(data);
    },
    events: {
      'click .js-btn-papers': 'papersClicked',
      'click .js-btn-curve': 'curveClicked'
    },
    initialize: function() {
      this.model = svs.maltipset.models.tipsInfo;
      this.checkBoxes = this.model.toJSON();
    },
    papersClicked: function(event) {
      this.checkBoxes.papersChecked = event.currentTarget.checked;
    },
    curveClicked: function(event) {
      this.checkBoxes.curveChecked = event.currentTarget.checked;
    }
  });
})(Backbone, _, svs);

 })(window);